export enum MultimediaType {
    Xray = 'Xray',
    OtherProviderNote = 'OtherProviderNote',
    InsuranceCard = 'InsuranceCard',
    LabReport = 'LabReport',
    MedicalRecords = 'MedicalRecords',
    VisitNoteImage = 'VisitNoteImage',
    ProfilePicture = 'ProfilePicture',
    FinalizedVisitNote = 'FinalizedVisitNote',
    Identification = 'Identification',
    ConsentForms = 'ConsentForms',
    MedicalNotes = 'MedicalNotes',
    RadiologyImages = 'RadiologyImages',
    EOB = 'EOBDoc',
  }

export enum MediaOriginatorType {
    Org = 'Org',
    Patient = 'Patient',
    Billing = 'Billing',
  }

export const DEFAULT_EMPTY_VALUE = '—';